import { Component, OnInit } from '@angular/core';
import Action from 'src/app/models/action';
import { ModalController, NavController, AlertController } from '@ionic/angular';
import { ActionpathService } from 'src/app/services/actionpath.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/global.service'
import Actionpath from "src/app/models/actionpath";

@Component({
  selector: 'app-select-goals',
  templateUrl: './select-goals.page.html',
  styleUrls: ['./select-goals.page.scss'],
})
export class SelectGoalsPage implements OnInit  {
  public goals: Actionpath[] = [];
  public selectedgoals: Actionpath[];
  public isLoadinggoals: Boolean;
  public fetchNewgoals: boolean = true;
  public visiblegoals;
  public maximum: number = undefined;
  public openGoals: Actionpath[] = [];
  public visibleOpenGoals: Actionpath[] = [];
  public hasMoreGoals: boolean = false;
  public isIosDevice: boolean = false;
  public skeletonRows: number[] = [1,2,3,4,5];
  private allGoals: Actionpath[] = [];
  private selectedGoalIds: Set<number> = new Set();
  private goalRenderLimit: number = 60;
  private goalRenderStep: number = 60;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private actionpathService: ActionpathService,
    private alertController: AlertController,
    private translateService: TranslateService,
    private globalService: GlobalService
  ) {}

  public async ngOnInit () {
    GlobalService.log("Selected goals:");
    GlobalService.log(this.selectedgoals);
    if(this.selectedgoals == undefined){
      this.selectedgoals = [];
    }
    this.isIosDevice = this.globalService.isIos();
    this.updateSelectedGoalIds();
    await this.ionViewDidEnterManual();
  }

  public ionViewDidEnterManual () {
    if (this.fetchNewgoals) {
      this.getgoals();
    } else { 
      this.fetchNewgoals = true; // Ensure fetchNewContacts is on for future contact selects
    }
  }

  public searchgoals(eventData){
    const sourceGoals = ActionpathService.Searchedgoals || this.allGoals;
    if(eventData.detail.value){
      let searchValue = eventData.detail.value.toLowerCase();
      GlobalService.log(searchValue);
      GlobalService.log(ActionpathService.Searchedgoals);

      this.goals = sourceGoals.filter(goal => goal.title && goal.title.toLowerCase().includes(searchValue));
      this.resetGoalRenderLimit();
      this.updateGoalViews();
      GlobalService.log(this.goals);
    } else {
      this.goals = [...sourceGoals];
      this.resetGoalRenderLimit();
      this.updateGoalViews();
    }
  }

  public searchedgoals(){
    return ActionpathService.Searchedgoals;
  }

  public async getgoals () {
    this.isLoadinggoals = true;
    this.goals = [];
    
    let goals = await this.actionpathService.getAllactionpaths();
    this.goals = [...goals];
    this.allGoals = [...this.goals];
    ActionpathService.Searchedgoals = this.allGoals;
    this.updateGoalViews();

    this.isLoadinggoals = false;
  }

  public dismiss(dismissed) {
    GlobalService.log(this.selectedgoals);
    GlobalService.log(dismissed);
    
    this.modalController.dismiss({
      dismissed: dismissed,
      goals: this.selectedgoals
    });
  }

  public goBack() {
    this.dismiss(false);
  }

  public submit() {
    this.dismiss(true);
  }

  private comparegoals (goal: Actionpath) {
    return x => (goal.id_action_path != undefined && x.id_action_path == goal.id_action_path);
  }

  public actionIsSelected (action: Actionpath): boolean {
    if(action.id_action_path == undefined) return this.selectedgoals.find(this.comparegoals(action)) != undefined;
    return this.selectedGoalIds.has(action.id_action_path);
  }

  public selectGoal (goal: Actionpath) {
    if(this.actionIsSelected(goal)) {
      this.selectedgoals.splice(this.selectedgoals.findIndex(this.comparegoals(goal)),1);
    } else {
      if(this.maximum == 1){
        this.selectedgoals = [];
      }
      this.selectedgoals.push(goal);
    }
    this.updateSelectedGoalIds();
    GlobalService.log(this.selectedgoals);
  }

  public loadMoreGoals($event = undefined) {
    this.goalRenderLimit += this.goalRenderStep;
    this.updateGoalViews();
    if($event) $event.target.complete();
  }

  public selectAll () {
    if (this.selectedgoals.length == this.goals.length) {
      this.selectedgoals = [];
    } else {
      this.selectedgoals = [...this.goals]
    }
    this.updateSelectedGoalIds();
  }
  
  isIos(){
    return this.globalService.isIos();
  }

  public trackByGoal(index: number, goal: Actionpath) {
    return goal?.id_action_path || index;
  }

  public trackByIndex(index: number) {
    return index;
  }

  private updateGoalViews() {
    this.openGoals = this.goals.filter(goal => goal.status == "OPEN");
    this.visibleOpenGoals = this.openGoals.slice(0, this.goalRenderLimit);
    this.hasMoreGoals = this.visibleOpenGoals.length < this.openGoals.length;
  }

  private updateSelectedGoalIds() {
    this.selectedGoalIds = new Set((this.selectedgoals || []).filter(goal => goal.id_action_path != undefined).map(goal => goal.id_action_path));
  }

  private resetGoalRenderLimit() {
    this.goalRenderLimit = this.goalRenderStep;
  }
}
